import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import styles from './BlockTypeButton.module.scss'

interface IBlockTypeButton {
  text: string
  icon: ReactNode
  onClick: any
  className?: string
  disabled?: boolean
  loading?: boolean
  variant?: 'default' | 'evaluation'
}

const BlockTypeButton: React.FC<IBlockTypeButton> = ({
  text,
  icon,
  onClick,
  className = '',
  disabled = false,
  loading = false,
  variant = 'default',
}) => {
  return (
    <a
      className={classNames(
        'd-flex flex-column align-items-center',
        styles.optionBlockButton,
        className,
        {
          [styles.disabled]: disabled,
          [styles.variantEvaluation]: variant === 'evaluation',
        }
      )}
      onClick={() => !disabled && onClick()}
    >
      {loading && (
        <div className={styles.loading}>
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      )}
      <span className={styles.blockOptionIconContainer}>{icon}</span>
      {text}
    </a>
  )
}

export default BlockTypeButton
